import React from 'react';
import InstituteCrudPage from './InstituteCrudPage';
import { extendedEntityConfigs } from '../../config/extendedEntityConfigs';
export default function ExtendedModulePage({ moduleKey }) { const config=extendedEntityConfigs[moduleKey]; return config ? <InstituteCrudPage config={config}/> : null; }
